import { useStore } from 'react-redux';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import Field from '../../../../../model/Field';
import { Tooltip, Typography } from '@mui/material';
import { getFieldName } from '../../../../../helpers/StateInterpreters';
import { useLangFile } from '../../../../../context/LanguageContext';
import { useSurveyForField } from '../../../useSurveyForField';
import { SURVEY_LAYERS } from '../../../../../constants/SurveyLayers';

const MissingSoilAnalysisTooltip = ({ children }) => {
  const store = useStore().getState();
  const [fieldsWithMissingSoilAnalysis, setFieldsWithMissingSoilAnalysis] = useState<Field[]>([]);
  const LangFile = useLangFile();
  const { getSurveyForFieldAndLayer } = useSurveyForField();

  useEffect(() => {
    let jobsToCheck = [];
    const prescription = store.prescription;

    if (prescription.isBulkPrescription) {
      jobsToCheck = Object.values(prescription.bulkPrescription.currentJobs);
    } else {
      jobsToCheck = [prescription.currentJob];
    }

    const jobs = jobsToCheck.filter(
      (job) => !getSurveyForFieldAndLayer(job.fieldId, SURVEY_LAYERS.CLAY)
    );
    setFieldsWithMissingSoilAnalysis(jobs.map((job) => store.field.fields.get(job.fieldId)));
  }, [setFieldsWithMissingSoilAnalysis]);

  const tooltipText = useMemo(() => {
    if (store.prescription.isBulkPrescription) {
      return (
        <Fragment>
          <Typography
            sx={{
              color: 'inherit',
            }}
          >
            {LangFile.PrescriptionSettings.adjustingDisabled.multipleFieldsLackSoilAnalysis}
          </Typography>
          <ul style={{ paddingLeft: '12px' }}>
            {fieldsWithMissingSoilAnalysis.map((field) => (
              <li key={field.fieldId}>{getFieldName(field, LangFile)}</li>
            ))}
          </ul>
        </Fragment>
      );
    }

    return <>{LangFile.PrescriptionSettings.adjustingDisabled.selectedFieldLackingSoilAnalysis}</>;
  }, [store.prescription.isBulkPrescription, getFieldName, fieldsWithMissingSoilAnalysis]);

  const isAnyFieldLackingSoilAnalysis = useMemo(() => {
    return fieldsWithMissingSoilAnalysis.length > 0;
  }, [fieldsWithMissingSoilAnalysis]);

  if (isAnyFieldLackingSoilAnalysis) {
    return (
      <Tooltip
        arrow
        title={tooltipText}
        slotProps={{
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -14],
                },
              },
            ],
          },
        }}
      >
        {React.cloneElement(React.Children.only(children), {
          disabled: true,
        })}
      </Tooltip>
    );
  }

  return <>{children}</>;
};

export default MissingSoilAnalysisTooltip;
